"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribedRunner = exports.SubscribedAsyncResponse = exports.SubscribedGTV = exports.SubscribedRTV = exports.SubscribedCTV = exports.SubscribedRacePool = exports.SubscribedRace = exports.SubscribedCard = exports.SubscribedSelection = exports.SubscribedExchangeEventTab = exports.SubscribedExchangeEvent = exports.SubscribedExchangeMarketTaggedValue = exports.SubscribedExchangeEventTaggedValue = exports.SubscribedExchangeSelection = exports.SubscribedExchangeMarket = exports.aapiId = void 0;
const CommonEnums_1 = require("../../Shared/Enums/CommonEnums");
var aapiId;
(function (aapiId) {
    aapiId[aapiId["setAnonymousSessionContext"] = 1] = "setAnonymousSessionContext";
    aapiId[aapiId["logonPunter"] = 2] = "logonPunter";
    aapiId[aapiId["logoffPunter"] = 3] = "logoffPunter";
    aapiId[aapiId["subscribePoolBettingSummary"] = 4] = "subscribePoolBettingSummary";
    aapiId[aapiId["subscribeRaceInformation"] = 5] = "subscribeRaceInformation";
    aapiId[aapiId["subscribeRacePools"] = 6] = "subscribeRacePools";
    aapiId[aapiId["subscribeCardTaggedValueChanges"] = 7] = "subscribeCardTaggedValueChanges";
    aapiId[aapiId["subscribeRaceTaggedValueChanges"] = 8] = "subscribeRaceTaggedValueChanges";
    aapiId[aapiId["subscribeMarketInformation"] = 9] = "subscribeMarketInformation";
    aapiId[aapiId["subscribeGenericTaggedValueChanges"] = 15] = "subscribeGenericTaggedValueChanges";
    aapiId[aapiId["subscribeOrders"] = 16] = "subscribeOrders";
    aapiId[aapiId["subscribeAsynchronousResponse"] = 18] = "subscribeAsynchronousResponse";
    aapiId[aapiId["unsubscribe"] = 20] = "unsubscribe";
    aapiId[aapiId["listSubscriptions"] = 21] = "listSubscriptions";
    aapiId[aapiId["ping"] = 22] = "ping";
    aapiId[aapiId["subscribeBalance"] = 23] = "subscribeBalance";
    aapiId[aapiId["setRefreshPeriod"] = 60] = "setRefreshPeriod";
    aapiId[aapiId["getRefreshPeriod"] = 61] = "getRefreshPeriod";
})(aapiId || (exports.aapiId = aapiId = {}));
class SubscribedObject {
    constructor() {
        this._delegates = {};
        this.delegateId = 0;
        this.addDelegate = (delegate) => {
            this._delegates[++this.delegateId] = delegate;
            return this.delegateId;
        };
        this.removeDelegate = (delegateId) => {
            delete this._delegates[delegateId];
        };
        this.fireDeltaDelegates = (data) => {
            for (const key in this._delegates) {
                this._delegates[key](data);
            }
        };
    }
}
class SubscribedExchangeMarket extends SubscribedObject {
    constructor() {
        super(...arguments);
        this.marketId = 0;
        this.genericId = 0;
        this.displayOrder = 0;
        this.eventClassifierId = 0;
        this.name = '';
        this.genericName = '';
        this.marketBlurb = '';
        this.description = '';
        this.isCurrentlyInRunning = false;
        this.status = CommonEnums_1.GBET.MarketStatus.Active;
        this.managedWhenInrunning = false;
        this.canBeInRunning = false;
        this.isEnabledForMultiples = false;
        this.marketType = CommonEnums_1.GBET.MarketType.Unspecified;
        this.bOGAvailable = false;
        this.resultString = '';
        this.withdrawalSequenceNumber = 0;
        //numberOfWinningSelections = 0;
        this.delayFactor = 0;
        this.startTime = '';
        this.numberWinningPlaces = 0;
        this.placeFraction = 0;
        this._selectionIndex = {};
    }
    get selections() {
        const selectionArray = [];
        for (const key in this._selectionIndex) {
            if (this._selectionIndex[key].marketId === this.marketId) {
                selectionArray.push(this._selectionIndex[key]);
            }
        }
        return selectionArray;
    }
}
exports.SubscribedExchangeMarket = SubscribedExchangeMarket;
class SubscribedExchangeSelection extends SubscribedObject {
}
exports.SubscribedExchangeSelection = SubscribedExchangeSelection;
class SubscribedExchangeEventTaggedValue extends SubscribedObject {
}
exports.SubscribedExchangeEventTaggedValue = SubscribedExchangeEventTaggedValue;
class SubscribedExchangeMarketTaggedValue extends SubscribedObject {
}
exports.SubscribedExchangeMarketTaggedValue = SubscribedExchangeMarketTaggedValue;
class SubscribedExchangeEvent extends SubscribedObject {
    constructor() {
        super(...arguments);
        this.isEnabledForMultiples = false;
    }
}
exports.SubscribedExchangeEvent = SubscribedExchangeEvent;
class SubscribedExchangeEventTab {
    constructor() {
        this.tabs = {};
    }
}
exports.SubscribedExchangeEventTab = SubscribedExchangeEventTab;
class SubscribedSelection {
    constructor(params) {
        this.selectionId = params.selectionId;
    }
}
exports.SubscribedSelection = SubscribedSelection;
class SubscribedCard {
    constructor() {
        this.cardDate = undefined;
        this.shortCardName = undefined;
        this.abbreviatedCardName = undefined;
        this.breedCode = undefined;
    }
}
exports.SubscribedCard = SubscribedCard;
class SubscribedRace {
    constructor() {
        this.raceId = undefined;
        this.raceStatusId = undefined;
        this.postTime = undefined;
        this.surface = undefined;
        this.changedSurface = undefined;
        this.distance = undefined;
        this.changedDistance = undefined;
        this.trackConditions = undefined;
        this.changedTrackConditions = undefined;
    }
}
exports.SubscribedRace = SubscribedRace;
class SubscribedRacePool {
    constructor() {
        this.raceId = undefined;
        this.poolId = undefined;
        this.poolStatusId = undefined;
        this.currentTotalBetPoolGross = undefined;
    }
}
exports.SubscribedRacePool = SubscribedRacePool;
class SubscribedCTV {
    constructor() {
        this.cardId = undefined;
        this.name = undefined;
        this.value = undefined;
    }
}
exports.SubscribedCTV = SubscribedCTV;
class SubscribedRTV {
    constructor() {
        this.raceId = undefined;
        this.name = undefined;
        this.value = undefined;
    }
}
exports.SubscribedRTV = SubscribedRTV;
class SubscribedGTV {
}
exports.SubscribedGTV = SubscribedGTV;
class SubscribedAsyncResponse {
    constructor() {
        this.name = undefined;
        this.value = undefined;
    }
}
exports.SubscribedAsyncResponse = SubscribedAsyncResponse;
class SubscribedRunner {
    constructor() {
        this.runnerId = undefined;
        this.runnerStatusId = undefined;
        this.priceTrendType = undefined;
        this.currentWinPrice = undefined;
        this.currentWinFractionalOdds = undefined;
        this.finishPosition = undefined;
        this.jockey = undefined;
        this.changedJockeyName = undefined;
        this.trainer = undefined;
        this.changedTrainer = undefined;
        this.equipment = undefined;
        this.changedEquipment = undefined;
        this.medication = undefined;
        this.changedMedication = undefined;
        this.horseSex = undefined;
        this.changedHorseSex = undefined;
        this.weightCarried = undefined;
        this.changedWeightCarried = undefined;
    }
}
exports.SubscribedRunner = SubscribedRunner;
